export const dateValidation = (d) => {
    return d instanceof Date && !isNaN(d);
}
